import { Box, Button, CircularProgress, Grid, Switch, Typography } from '@mui/material'

import FileInput from 'src/Component/FileInput'
import InputField from 'src/Component/InputField'

import SimpleModal from 'src/Component/SimpleModal'
import useAddHook from './useAddHook'
import { Controller } from 'react-hook-form'
import SimpleDropdown from 'src/Component/SimpleDropdown'
import { useGetCategoriesByTypeQuery } from 'src/api/manageProductsApi'
import { PRODUCT_TYPES } from 'src/utils/constants'
import { useEffect } from 'react'

type AddModalProps = {
  open: boolean
  onClose: () => void
  successCallback: () => void
}
const AddModal = ({ open, onClose, successCallback }: AddModalProps) => {
  const {
    file,
    handleFileChange,
    control,
    errors,
    onSubmit,
    isLoadingAddProduct,
    resetCategory,
    watchState: { productType },
    handleChangeStatus
  } = useAddHook({
    successCallback,
  })
  const { data: CATEGORIES = [], isFetching: isFetchingCategories } =
    useGetCategoriesByTypeQuery(productType)

  useEffect(() => {
    resetCategory()
  }, [CATEGORIES])
  return (
    <Box>
      <SimpleModal open={open} onClose={onClose}>
        <form onSubmit={onSubmit}>
          <Box>
            <FileInput
              type='image'
              title='You can click me to upload files!'
              discription='Support for  image file formats (.png, .jpeg)'
              name='fileuplaod'
              value={file}
              onChange={handleFileChange}
              showPreview
            />

            <Grid container mt={3}>
              <Grid xs={8}>
                <Grid container>
                  <Grid xs={4}>
                    <Typography variant='h4' component='p'>
                      Active/In-Active
                    </Typography>
                  </Grid>
                  <Grid xs={8}>
                  <Controller
                  name='isActive'
                  control={control}
                  rules={{ required: true }}
                  render={({ field }) => (
                    <>
                    <Switch
                      color='error'
                      checked={field.value}
                      onChange={handleChangeStatus}
                    />
                      {!!errors.isActive && (
                        <Grid container justifyContent='right'>
                          <Typography variant='subtitle2' color='red' textAlign='right'>
                            {errors.isActive.message}
                          </Typography>
                        </Grid>
                      )}
                    </>
                  )}
                />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
            <Grid container>
              <Grid xs={8} mb={2}>
                <Controller
                  name='title'
                  control={control}
                  rules={{ required: true }}
                  render={({ field }) => (
                    <>
                      <InputField
                        name={field.name}
                        type='text'
                        label='Product Name'
                        placeholder='Enter product name'
                        value={field.value}
                        onChange={field.onChange}
                        // error={!!errors.title}
                        required
                      />
                      {!!errors.title && (
                        <Grid container justifyContent='right'>
                          <Typography variant='subtitle2' color='red' textAlign='right'>
                            {errors.title.message}
                          </Typography>
                        </Grid>
                      )}
                    </>
                  )}
                />
              </Grid>
            </Grid>

            <Grid container>
              <Grid xs={8} mb={2}>
                <Controller
                  name='productType'
                  control={control}
                  rules={{ required: true }}
                  render={({ field }) => (
                    <>
                      <SimpleDropdown
                        required
                        label={'Product Type'}
                        id={field.name}
                        name={field.name}
                        value={field.value}
                        onChange={field.onChange}
                        options={PRODUCT_TYPES?.map((type) => {
                          return {
                            value: type,
                            label: type,
                          }
                        })}
                        placeholder='Select product type'
                        // error={!!errors.productType}
                      />
                      {!!errors.productType && (
                        <Grid container justifyContent='right'>
                          <Typography variant='subtitle2' color='red' textAlign='right'>
                            {errors.productType.message}
                          </Typography>
                        </Grid>
                      )}
                    </>
                  )}
                />
              </Grid>
            </Grid>

            <Grid container>
              <Grid xs={8} mb={2}>
                <Controller
                  name='price'
                  control={control}
                  rules={{ required: true }}
                  render={({ field }) => (
                    <>
                      <InputField
                        name={field.name}
                        type='number'
                        regex={/[^0-9]*$/}
                        label='Amount per unit'
                        placeholder='Enter amount'
                        value={field.value === 0 ? '' : field.value}
                        onChange={field.onChange}
                        // error={!!errors.price}
                        required
                      />
                      {!!errors.price && (
                        <Grid container justifyContent='right'>
                          <Typography variant='subtitle2' color='red' textAlign='right'>
                            {errors.price.type === 'typeError'
                              ? 'Price shoule be number'
                              : errors.price.message}
                          </Typography>
                        </Grid>
                      )}
                    </>
                  )}
                />
              </Grid>
            </Grid>

            <Grid container>
              <Grid xs={8} mb={2}>
                <Controller
                  name='unit'
                  control={control}
                  rules={{ required: true }}
                  render={({ field }) => (
                    <>
                      <InputField
                        name={field.name}
                        type='text'
                        label='Unit'
                        placeholder='Enter unit'
                        value={field.value}
                        onChange={field.onChange}
                        // error={!!errors.unit}
                        required
                      />
                      {!!errors.unit && (
                        <Grid container justifyContent='right'>
                          <Typography variant='subtitle2' color='red' textAlign='right'>
                            {errors.unit.message}
                          </Typography>
                        </Grid>
                      )}
                    </>
                  )}
                />
              </Grid>
            </Grid>

            <Grid container>
              <Grid xs={8} mb={2}>
                <Controller
                  name='category'
                  control={control}
                  rules={{ required: true }}
                  render={({ field }) => (
                    <>
                      <SimpleDropdown
                        required
                        disabled={isFetchingCategories}
                        label={'Category'}
                        id={field.name}
                        name={field.name}
                        value={field.value === 0 ? '' : field.value}
                        onChange={field.onChange}
                        options={CATEGORIES?.map((category) => {
                          return {
                            value: category.id,
                            label: category.name,
                          }
                        })}
                        placeholder='Select category'
                        // error={!!errors.category}
                      />
                      {!!errors.category && (
                        <Grid container justifyContent='right'>
                          <Typography variant='subtitle2' color='red' textAlign='right'>
                            {errors.category.message}
                          </Typography>
                        </Grid>
                      )}
                    </>
                  )}
                />
              </Grid>
            </Grid>

            <Grid container>
              <Grid xs={8} mb={2}>
                <Controller
                  name='description'
                  control={control}
                  rules={{ required: true }}
                  render={({ field }) => (
                    <>
                      <InputField
                        name={field.name}
                        type='text'
                        label='Description'
                        multiline
                        rows={4}
                        placeholder='Enter description'
                        value={field.value}
                        onChange={field.onChange}
                        // error={!!errors.description}
                        required
                      />
                      {!!errors.description && (
                        <Grid container justifyContent='right'>
                          <Typography variant='subtitle2' color='red' textAlign='right'>
                            {errors.description.message}
                          </Typography>
                        </Grid>
                      )}
                    </>
                  )}
                />
              </Grid>
            </Grid>

            <Button
              variant='contained'
              color='primary'
              type='submit'
              disabled={isLoadingAddProduct}
            >
              {isLoadingAddProduct ? <CircularProgress size={25} color='error' /> : 'SAVE'}
            </Button>
          </Box>
        </form>
      </SimpleModal>
    </Box>
  )
}

export default AddModal
